import React from "react"

const ViewOffIcon = () => {
    return (
        <div className="transition-transform duration-300 ease-in-out transform rotate-0 group-hover:rotate-180">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.6667 5.33334C14.6667 5.33334 12 9.33334 8 9.33334C4 9.33334 1.33334 5.33334 1.33334 5.33334" stroke="#2D2D2D" stroke-width="1.5" stroke-linecap="round" />
                <path d="M10 9L11 10.6667" stroke="#2D2D2D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M13.3333 7.33334L14.6667 8.66668" stroke="#2D2D2D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M1.33334 8.66669L2.66667 7.33335" stroke="#2D2D2D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M6 9L5 10.6667" stroke="#2D2D2D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </div>
    )
}
export default ViewOffIcon